import React from "react";
import { IdentificationContent, Metadada } from "./styles";

import nameImg from "../../../../../assets/images/nameIcon.svg";
import foneImg from "../../../../../assets/images/foneIcon.svg";
import emailImg from "../../../../../assets/images/emailIcon.svg";

const PayerIdentification = (props) => {
  return (
    <>
      <h2>Identificação</h2>
      <IdentificationContent>
        <Metadada>
          <img src={nameImg} />
          <span>{props.identificationData.name.toUpperCase()}</span>
        </Metadada>
        <Metadada>
          <img src={foneImg} />
          <span>{props.identificationData.phone}</span>
        </Metadada>
        <Metadada>
          <img src={emailImg} />
          <span>{props.identificationData.email}</span>
        </Metadada>
      </IdentificationContent>
    </>
  );
};

export default PayerIdentification;
